// Utility to suppress specific integration-related error messages
const originalConsoleError = console.error; 

console.error = function(...args) { 
  // Check if this is an integration 404 error message that we want to suppress
  if (args[0] && typeof args[0] === 'string' && args[0].includes('Error fetching product integration')) {
    return; 
  }
  
  // For all other errors, use the original console.error
  originalConsoleError.apply(console, args); 
}; 